import React, { Component, Fragment } from 'react'
import moment from 'moment'
import { Query } from 'react-apollo'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import SearchInput from '../../components/SearchInput/'
import OrderTable from '../../components/OrderTable/'
import EmployeeCTA from '../../components/EmployeeCTA/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { SELF_QUERY } from '../../queries'

import { Container } from '../../styles/defaults'
import { PageTitle, SearchContainer, InfoContainer, CompanyInfo, MiniContainer } from './styles'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'
import employee from '../../assets/cta/employee.png'

class OrderHistory extends Component {

  constructor(props) {
    super(props)
    this.state = {
      oldOrders: []
    }
  }

  // Sort oldOrders based on date
  componentDidMount() {
    this.setState({ oldOrders: this.props.oldOrders.sort((a, b) => new Date(b.deliveryDate) - new Date(a.deliveryDate)) })
  }

  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })
    this.setState({ 
      oldOrders: this.props.oldOrders.filter(oldOrder => {
        let deliveryDate = moment(oldOrder.deliveryDate).format('DD-MM-YYYY')
        let orderNumber = oldOrder.orderNumber.toString().toLowerCase().slice(0, queryLength)
        return (
          deliveryDate.includes(query) ||
          orderNumber === query
        )
      }).sort((a, b) => new Date(b.deliveryDate) - new Date(a.deliveryDate))
    })
  }

  formatOldOrders(oldOrders) {
    const items = []
    oldOrders.map(oldOrder => {
      // Filter out all orderparts with forbidden products
      return items.push({
        id: oldOrder.id,
        one: moment(oldOrder.deliveryDate).format('DD-MM-YYYY'),
        two: oldOrder.orderNumber,
        // three: assort,
        // four: amount > 0 ?  amount.toString() + ' st.' : ''
      })
    })

    return items
  }

  render() {
    const { oldOrders } = this.state
    let formattedOldOrders = this.formatOldOrders(oldOrders)
    const headers = ['Leverdatum', 'Ordernummer']
    return (
      <Fragment>
        <Hero setsize="small" small={hero} medium={hero} large={hero} retina={hero} title="Orderhistorie" />
        <Breadcrumb title="Orderhistorie" />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="45%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            let viewOrders = (self.permissions.includes('VIEW_OLD_ORDER') || self.role === 'MANAGER') && !this.props.branch.suspended


            return (
              <Fragment>
                <Container mt>
                  <PageTitle>Overzicht orders</PageTitle>
                </Container>
                <InfoContainer full>
                  <CompanyInfo>
                    {this.state.oldOrders.length} orders
                  </CompanyInfo>
                  <SearchContainer>
                    <SearchInput placeholder="Zoeken" onSearch={this.onSearch.bind(this)} />
                  </SearchContainer>
                </InfoContainer>
                {(viewOrders) ? (
                  <Container mt mb>
                    {oldOrders.length > 0 ? (
                      <Fragment>
                        <OrderTable
                          headers={headers}
                          items={formattedOldOrders}
                          data={data}
                          loading={loading}
                          error={error}
                        />
                        <MiniContainer full>
                          <EmployeeCTA
                            size={'medium'}
                            content={{
                              title: 'Vragen over een order?',
                              subtitle: 'We helpen u graag',
                              employee: true,
                              image: employee,
                              link: {
                                content: 'Contact',
                                url: '/contact',
                                target: ''
                              }
                            }}
                          />
                        </MiniContainer>

                      </Fragment>

                      
                    ) : <Fragment>Er zijn geen orders beschikbaar</Fragment>}
                  </Container>
                ) : (
                  <Container mt mb>Onvoldoende rechten om de bestellingen te bekijken</Container>
                )}
              </Fragment>
            )
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(OrderHistory)



// WEBPACK FOOTER //
// ./src/views/OrderHistory/index.js